export default __webpack_public_path__ + "static/media/tips3.bc7f676a.png";